import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetDashboardTotalViewsInterface {
  startDate: string;
  endDate: string;
}

export const useGetDashboardTotalViews = () => {
  const mutate = useMutation(({ startDate, endDate }: GetDashboardTotalViewsInterface) => {
    return get(`/external-api/get_total_views_bydaterange/${startDate}/${endDate}`);
  });

  return mutate;
};

export default useGetDashboardTotalViews;
